
/**
 * 기본 사용자 정보
 */
export type ProjectCommentListResponsePageAllOfThreeContentItemAuthor = {
  /** 표시 이름 */
  displayName: string;
  /** 사용자 ID */
  id: number;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
  /** 사용자명 */
  username: string;
};
